export function userLang() {
  const userLang = window.navigator.language

  return {
    isKo: userLang.includes('ko'),
    isEn: userLang.includes('en'),
  }
}
